export default {
      id: "notifications__input-usage",
      viewBox: "0 0 92.69 88.18",
      url: __webpack_public_path__ + "img/icons.svg#notifications__input",
      toString: function () {
        return this.url;
      }
    }